export class CancellablePromise {
    constructor(promise, cancel = () => { }) {
        this[Symbol.toStringTag] = 'CancellablePromise';
        this.cancel = () => { };
        this.promise = promise;
        this.cancel = cancel;
    }
    static all(values) {
        function cancel() {
            for (const promise of values) {
                promise.cancel();
            }
        }
        return new CancellablePromise(Promise.all(values), cancel);
    }
    static race(values) {
        function cancel() {
            for (const promise of values) {
                promise.cancel();
            }
        }
        return new CancellablePromise(Promise.race(values), cancel);
    }
    then(onfulfilled, onrejected) {
        var _a;
        return new CancellablePromise((_a = this.promise) === null || _a === void 0 ? void 0 : _a.then(onfulfilled, onrejected), this.cancel);
    }
    catch(onrejected) {
        var _a;
        return new CancellablePromise((_a = this.promise) === null || _a === void 0 ? void 0 : _a.catch(onrejected), this.cancel);
    }
    finally(onfinally) {
        var _a;
        return new CancellablePromise((_a = this.promise) === null || _a === void 0 ? void 0 : _a.finally(onfinally), this.cancel);
    }
}
